import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
// import './App.scss'

import store from "./store/state-tree";
import StoryContext from "./store/context";
import MainLayout from "./layouts/mainlayout";
import { observer } from "mobx-react-lite";

import Home from "./pages/home";
import Сhange1c from "./pages/change1c";
import About from "./pages/about";
import Photos from "./pages/photos";
import Matrix from "./pages/matrix";
import Routes from "./pages/routes";
import Report from "./pages/report";
import Auth from "./pages/auth";
import User from "./pages/user";
import ReportSilpo from "./pages/reportSilpo";
import ReportSalary from "./pages/ReportSalary";
import ReportAmount from "./pages/RepostAmount";
import Order from "./pages/Order";

const App = observer(() => {
  // console.log(store.isAuth)
  return (
    <StoryContext.Provider value={store}>
      <main className="main">
        <Router>
          {!store.isAuth ? (
            <Route path="*" exact component={Auth} />
          ) : (
            <MainLayout>
              <Route path="/" exact component={Home} />
              <Route path="/change1c" component={Сhange1c} />
              <Route path="/routes" component={Routes} />
              <Route path="/matrix" component={Matrix} />
              <Route path="/about" component={About} />
              <Route path="/photos" component={Photos} />
              <Route path="/report" component={Report} />
              <Route path="/reportsilpo" component={ReportSilpo} />
              <Route path="/repostsalary" component={ReportSalary} />
              <Route path="/reportamount" component={ReportAmount} />
              <Route path="/user" component={User} />
              <Route path="/order" component={Order} />
            </MainLayout>
          )}
        </Router>
      </main>
    </StoryContext.Provider>
  );
});

export default App;
